import { css } from '@emotion/core';

import { flex, SPACE_MINIMUM, SPACE_COMPACT } from '@/styles';

export const root = [
  flex,
  css`
    flex-flow: column;
  `,
];

export const list = css`
  display: flex;
  flex-flow: column;

  margin-top: ${SPACE_COMPACT}px;
  margin-left: -${SPACE_MINIMUM}px; /* NOTE: This counteracts AK Tags intrinsic margin. */
  margin-bottom: ${SPACE_COMPACT}px; /* NOTE: This gives the 'faded bottom' effect room. */
  padding: ${SPACE_MINIMUM}px;

  & > * {
    margin-top: ${SPACE_COMPACT}px;
  }
`;
